// import React, { useState, useEffect } from "react";
// import {
//   ShoppingCart,
//   Star,
//   ChevronRight,
//   Home,
//   Loader2,
//   Heart,
// } from "lucide-react";
// import { useParams, useNavigate } from "react-router-dom";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import axios from "axios";
// import { toast } from "react-hot-toast";
// import { useCart } from "../../../utils/CartContext";
// import ProductDetailsSkeleton from "./ProductDetailsSkeleton";
// import { formatingPrice } from "../../../utils/formatingPrice";
// import { useCurrency } from "../../../context/CurrencyContext";

// const ProductDetailsPage = () => {
//   const { currency, convertPrice } = useCurrency();
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const { fetchCartCount } = useCart();

//   const [product, setProduct] = useState(null);
//   const [selectedImage, setSelectedImage] = useState("");
//   const [animate, setAnimate] = useState(false);
//   const [quantity, setQuantity] = useState(1);
//   const [loading, setLoading] = useState(true);
//   const [relatedProducts, setRelatedProducts] = useState([]);
//   const [isCartLoading, setIsCartLoading] = useState(false);
//   const [wishlist, setWishlist] = useState([]);
//   const [loadingHearts, setLoadingHearts] = useState(new Set());

//   const storedUser = localStorage.getItem("pm-user-data");
//   const user = storedUser ? JSON.parse(storedUser) : null;
//   const userId = user?._id;

//   // Helper to extract localized text (default: English)
//   const getLocalizedText = (field, defaultLang = "en") => {
//     if (!field) return "";
//     if (typeof field === "string") return field;
//     if (typeof field === "object" && field[defaultLang]) return field[defaultLang];
//     // Fallback to first available language value
//     const firstValue = Object.values(field)[0];
//     return firstValue || "";
//   };

//   useEffect(() => {
//     const fetchProduct = async () => {
//       try {
//         setLoading(true);
//         const res = await axios.get(
//           `${process.env.REACT_APP_API_URL}/products/get-product-by-id/${id}`
//         );
//         const prod = res.data.product;
//         setProduct(prod);
//         setSelectedImage(prod?.images?.[0]);

//         const categoryId = prod?.category?._id;
//         if (categoryId) {
//           const relatedRes = await axios.get(
//             `${process.env.REACT_APP_API_URL}/products/sub-categories-products-by-category/${categoryId}`
//           );
//           const flatProducts =
//             relatedRes.data?.data?.flatMap((item) => item.products || []) || [];
//           const filteredRelated = flatProducts.filter((p) => p._id !== id);
//           setRelatedProducts(filteredRelated);
//         }
//       } catch (err) {
//         console.error("Error fetching product:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchProduct();
//   }, [id]);

//   useEffect(() => {
//     AOS.init({ duration: 800, easing: "ease-out", once: true });
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   const fetchWishlist = async () => {
//     if (!userId) {
//       const localWishlist = JSON.parse(
//         localStorage.getItem("guestWishlist") || "[]"
//       );
//       setWishlist(localWishlist);
//       return;
//     }
//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/wishlist/wishlist-by-user/${userId}`
//       );
//       const ids = res?.data?.products?.map((p) => p._id?.toString()) || [];
//       setWishlist(ids);
//     } catch (error) {
//       console.error("❌ Error fetching wishlist:", error);
//     }
//   };

//   useEffect(() => {
//     fetchWishlist();
//   }, [userId]);

//   const toggleWishlist = async (productId) => {
//     if (!userId) {
//       toast.error("Please login to use wishlist ❤️");
//       return;
//     }

//     const isLiked = wishlist.includes(productId.toString());
//     setLoadingHearts((prev) => new Set(prev).add(productId));

//     try {
//       const endpoint = isLiked
//         ? `${process.env.REACT_APP_API_URL}/wishlist/remove-from-wishlist`
//         : `${process.env.REACT_APP_API_URL}/wishlist/add-to-wishlist`;

//       await axios.post(endpoint, { userId, productId });
//       await fetchWishlist();
//     } catch (error) {
//       toast.error("Something went wrong!");
//     } finally {
//       setLoadingHearts((prev) => {
//         const newSet = new Set(prev);
//         newSet.delete(productId);
//         return newSet;
//       });
//     }
//   };

//   const handleAddToCart = async (productId) => {
//     if (!userId) {
//       toast.error("Please login to add items to cart 🛒");
//       return;
//     }

//     setIsCartLoading(true);
//     try {
//       await axios.post(
//         `${process.env.REACT_APP_API_URL}/cart/add-product-to-cart`,
//         { userId, productId, quantity }
//       );
//       toast.success("Added to cart!");
//       fetchCartCount();
//     } catch (error) {
//       toast.error("Failed to add to cart");
//     } finally {
//       setIsCartLoading(false);
//     }
//   };

//   const handleThumbnailClick = (img) => {
//     setAnimate(true);
//     setTimeout(() => {
//       setSelectedImage(img);
//       setAnimate(false);
//     }, 200);
//   };

//   const handleProductClick = (id) => navigate(`/product-details/${id}`);

//   if (loading) return <ProductDetailsSkeleton />;

//   if (!product)
//     return (
//       <div className="flex justify-center items-center h-screen text-gray-500">
//         Product not found.
//       </div>
//     );

//   return (
//     <div className="min-h-screen bg-gray-50">
//       <div className="bg-white border-b sticky top-0 z-10">
//         <div className="w-full mx-auto px-4 md:px-10 py-3 flex items-center text-sm text-gray-600">
//           <button
//             onClick={() => navigate("/")}
//             className="hover:text-gray-900 flex items-center gap-1"
//           >
//             <Home className="w-4 h-4" />
//             Home
//           </button>
//           <ChevronRight className="w-4 h-4 mx-2" />
//           <span className="text-gray-900 font-medium truncate">
//             {getLocalizedText(product?.name)}
//           </span>
//         </div>
//       </div>

//       {/* Product Details Section */}
//       <div className="w-full mx-auto px-4 md:px-10 py-10">
//         <div className="grid md:grid-cols-2 gap-10 items-start">
//           {/* Image Gallery */}
//           <div className="space-y-4" data-aos="fade-right">
//             <div className="bg-white border rounded-xl shadow-lg flex items-center justify-center h-96 overflow-hidden">
//               <img
//                 src={selectedImage}
//                 alt={getLocalizedText(product?.name)}
//                 className={`h-full w-auto object-contain transition-all duration-300 ease-in-out ${
//                   animate ? "opacity-0 scale-95" : "opacity-100 scale-100"
//                 }`}
//               />
//             </div>
//             <div className="grid grid-cols-4 gap-3">
//               {product.images?.map((img, i) => (
//                 <div
//                   key={i}
//                   onClick={() => handleThumbnailClick(img)}
//                   className={`bg-white border rounded-lg h-20 flex items-center justify-center cursor-pointer overflow-hidden hover:border-yellow-500 transition ${
//                     selectedImage === img
//                       ? "border-[#976C00]"
//                       : "border-gray-200"
//                   }`}
//                 >
//                   <img
//                     src={img}
//                     alt={`thumb-${i}`}
//                     className="h-full object-contain"
//                   />
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Info */}
//           <div data-aos="fade-left" className="space-y-4">
//             <h1 className="text-3xl font-semibold text-[#9F7100]">
//               {getLocalizedText(product?.name)}
//             </h1>

//             <div className="flex items-center gap-2">
//               {[...Array(5)].map((_, i) => (
//                 <Star
//                   key={i}
//                   className={`w-5 h-5 ${
//                     i < Math.round(product.ratings)
//                       ? "text-yellow-400 fill-yellow-400"
//                       : "text-gray-300"
//                   }`}
//                 />
//               ))}
//               <span className="text-gray-600 text-sm">
//                 {product.ratings?.toFixed(1)} / 5
//               </span>
//             </div>

//             <div className="text-4xl font-bold text-gray-900">
//               {formatingPrice(
//                 convertPrice(product.price?.toLocaleString()),
//                 currency
//               )}
//             </div>
//             {product.previous_price && (
//               <div className="text-gray-400 line-through">
//                 {formatingPrice(convertPrice(product.previous_price), currency)}
//               </div>
//             )}

//             <p className="text-gray-600 leading-relaxed">
//               {getLocalizedText(product?.description)}
//             </p>

//             {/* Add to Cart */}
//             <div className="flex gap-4 items-center mt-4">
//               <div className="flex items-center border rounded-lg">
//                 <button
//                   onClick={() => setQuantity(Math.max(1, quantity - 1))}
//                   className="px-4 py-2 hover:bg-gray-100"
//                 >
//                   −
//                 </button>
//                 <span className="px-4 py-2 border-x">{quantity}</span>
//                 <button
//                   onClick={() => setQuantity(quantity + 1)}
//                   className="px-4 py-2 hover:bg-gray-100"
//                 >
//                   +
//                 </button>
//               </div>
//               <button
//                 onClick={() => handleAddToCart(product._id)}
//                 disabled={isCartLoading}
//                 className="flex items-center justify-center gap-2 bg-[#9F7100] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#805900] transition"
//               >
//                 {isCartLoading ? (
//                   <Loader2 className="w-4 h-4 animate-spin" />
//                 ) : (
//                   <ShoppingCart className="w-5 h-5" />
//                 )}
//                 Add to Cart
//               </button>
//             </div>

//             {/* Product Details */}
//             <div>
//               <h3 className="font-semibold text-lg text-[#9F7100] mt-6 mb-2">
//                 Product Details
//               </h3>
//               <div className="bg-white border rounded-lg p-4 grid grid-cols-2 gap-3 text-sm">
//                 <p>
//                   <strong>Material:</strong>{" "}
//                   {getLocalizedText(product.material) || "—"}
//                 </p>
//                 <p>
//                   <strong>Height:</strong>{" "}
//                   {getLocalizedText(product.height) || "—"}
//                 </p>
//                 <p>
//                   <strong>Weight:</strong>{" "}
//                   {getLocalizedText(product.weight) || "—"}
//                 </p>
//                 <p>
//                   <strong>Finish:</strong>{" "}
//                   {getLocalizedText(product.finishType) || "—"}
//                 </p>
//                 <p>
//                   <strong>Origin:</strong>{" "}
//                   {getLocalizedText(product.origin) || "—"}
//                 </p>
//                 <p>
//                   <strong>Measurement:</strong>{" "}
//                   {getLocalizedText(product.measurement) || "—"}
//                 </p>
//                 <p>
//                   <strong>Return Policy:</strong>{" "}
//                   {getLocalizedText(product.return_policy) || "—"}
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Reviews */}
//         <div className="mt-16" data-aos="fade-up">
//           <h2 className="text-2xl font-philosopher text-[#9F7100] mb-6">
//             Customer Reviews
//           </h2>
//           <div className="bg-white border rounded-lg p-6 text-center text-gray-500">
//             No reviews yet. Be the first to review this product!
//           </div>
//         </div>

//         {relatedProducts.length > 0 && (
//           <div className="mt-16" data-aos="fade-up">
//             <h2 className="text-2xl font-philosopher text-[#9F7100] mb-6">
//               Related Products
//             </h2>
//             <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
//               {relatedProducts.map((productItem, index) => {
//                 const productId = productItem._id?.toString();
//                 const isLiked = wishlist.includes(productId);
//                 const isHeartLoading = loadingHearts.has(productId);

//                 return (
//                   <div
//                     key={productId}
//                     onClick={() => handleProductClick(productId)}
//                     className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-all cursor-pointer duration-300 relative"
//                     data-aos="fade-up"
//                     data-aos-delay={index * 100}
//                   >
//                     {/* Wishlist */}
//                     <button
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         toggleWishlist(productId);
//                       }}
//                       disabled={isHeartLoading}
//                       className="absolute top-3 right-3 z-10 p-2 rounded-full bg-white/90 shadow-md hover:bg-gray-100 transition-all duration-300"
//                     >
//                       {isHeartLoading ? (
//                         <Loader2 className="w-4 h-4 text-red-500 animate-spin" />
//                       ) : (
//                         <Heart
//                           className={`w-5 h-5 ${
//                             isLiked
//                               ? "fill-red-500 stroke-red-500"
//                               : "stroke-gray-800 hover:scale-110"
//                           } transition-all`}
//                         />
//                       )}
//                     </button>

//                     {/* Image */}
//                     <div className="relative bg-[#E5E5E5] overflow-hidden aspect-square">
//                       <img
//                         src={
//                           productItem.images?.[0] ||
//                           "https://via.placeholder.com/300x300?text=No+Image"
//                         }
//                         alt={getLocalizedText(productItem?.name)}
//                         className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
//                       />
//                     </div>

//                     {/* Info */}
//                     <div className="p-3 md:p-4">
//                       <div className="flex justify-center gap-1 mb-2">
//                         {[...Array(5)].map((_, i) => (
//                           <Star
//                             key={i}
//                             className={`w-4 h-4 ${
//                               i < Math.round(productItem.ratings)
//                                 ? "text-yellow-400 fill-yellow-400"
//                                 : "text-gray-300"
//                             }`}
//                           />
//                         ))}
//                         <span className="text-xs text-gray-500 ml-1">
//                           {productItem.ratings?.toFixed(1) || "0.0"}
//                         </span>
//                       </div>

//                       <h3 className="text-xs sm:text-sm text-gray-700 text-center mb-2 line-clamp-2 min-h-[2.5rem] leading-tight">
//                         {getLocalizedText(productItem?.name)}
//                       </h3>

//                       <div className="text-center">
//                         <div className="flex items-center justify-center gap-2">
//                           {productItem.previous_price && (
//                             <span className="text-xs sm:text-sm text-gray-400 line-through">
//                               {formatingPrice(
//                                 convertPrice(productItem.previous_price),
//                                 currency
//                               )}
//                             </span>
//                           )}
//                           <span className="text-base sm:text-lg font-bold text-gray-900">
//                             {formatingPrice(
//                               convertPrice(productItem.price),
//                               currency
//                             )}
//                           </span>
//                         </div>
//                       </div>

//                       <button
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleAddToCart(productId);
//                         }}
//                         disabled={isCartLoading}
//                         className="mt-3 w-full bg-white border-2 border-gray-900 text-gray-900 py-2.5 text-sm font-bold rounded-lg hover:bg-gray-900 hover:text-white transition-all duration-300 transform hover:scale-[1.02] disabled:opacity-70"
//                       >
//                         {isCartLoading ? (
//                           <div className="flex justify-center items-center gap-2">
//                             <Loader2 className="w-4 h-4 animate-spin" />
//                             ADDING...
//                           </div>
//                         ) : (
//                           "ADD TO CART"
//                         )}
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ProductDetailsPage;



import React, { useState, useEffect } from "react";
import {
  ShoppingCart,
  Star,
  ChevronRight,
  Home,
  Loader2,
  Heart,
  Share2,
  ShieldCheck,
  Truck,
  RotateCcw,
  MapPin,
} from "lucide-react";
import { useParams, useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { toast } from "react-hot-toast";
import { useCart } from "../../../utils/CartContext";
import ProductDetailsSkeleton from "./ProductDetailsSkeleton";
import { formatingPrice } from "../../../utils/formatingPrice";
import { useCurrency } from "../../../context/CurrencyContext";

// ---- Guest (no-login) cart & wishlist helpers -----------------------------
// Same keys as ProductCard.jsx — keep these two files in sync, or better,
// move this block into a shared file e.g. utils/guestStorage.js and import
// it from both places.
const GUEST_CART_KEY = "guestCart"; // [{ productId, quantity }]
const GUEST_WISHLIST_KEY = "guestWishlist"; // [productId, ...]

const getGuestCart = () => {
  try {
    return JSON.parse(localStorage.getItem(GUEST_CART_KEY) || "[]");
  } catch {
    return [];
  }
};

const setGuestCart = (cart) => {
  localStorage.setItem(GUEST_CART_KEY, JSON.stringify(cart));
  window.dispatchEvent(new Event("guest-cart-updated"));
};

const getGuestWishlist = () => {
  try {
    return JSON.parse(localStorage.getItem(GUEST_WISHLIST_KEY) || "[]");
  } catch {
    return [];
  }
};

const setGuestWishlist = (wishlist) => {
  localStorage.setItem(GUEST_WISHLIST_KEY, JSON.stringify(wishlist));
  window.dispatchEvent(new Event("guest-wishlist-updated"));
};

const addToGuestCart = (productId, quantity = 1) => {
  const cart = getGuestCart();
  const existing = cart.find((item) => item.productId === productId);
  if (existing) {
    existing.quantity += quantity;
  } else {
    cart.push({ productId, quantity });
  }
  setGuestCart(cart);
};

const toggleGuestWishlistItem = (productId) => {
  const wishlist = getGuestWishlist();
  const idx = wishlist.indexOf(productId);
  if (idx >= 0) {
    wishlist.splice(idx, 1);
  } else {
    wishlist.push(productId);
  }
  setGuestWishlist(wishlist);
  return wishlist;
};
// ----------------------------------------------------------------------------

const ProductDetailsPage = () => {
  const { currency, convertPrice } = useCurrency();
  const { id } = useParams();
  const navigate = useNavigate();
  const { fetchCartCount } = useCart();

  const [product, setProduct] = useState(null);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(true);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [isCartLoading, setIsCartLoading] = useState(false);
  const [wishlist, setWishlist] = useState([]);
  const [loadingHearts, setLoadingHearts] = useState(new Set());

  const storedUser = localStorage.getItem("pm-user-data");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const userId = user?._id;

  // Helper to extract localized text (default: English)
  const getLocalizedText = (field, defaultLang = "en") => {
    if (!field) return "";
    if (typeof field === "string") return field;
    if (typeof field === "object" && field[defaultLang]) return field[defaultLang];
    const firstValue = Object.values(field)[0];
    return firstValue || "";
  };

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/products/get-product-by-id/${id}`
        );
        const prod = res.data.product;
        setProduct(prod);
        setSelectedImage(prod?.images?.[0]);
        setSelectedIndex(0);

        const categoryId = prod?.category?._id;
        if (categoryId) {
          const relatedRes = await axios.get(
            `${process.env.REACT_APP_API_URL}/products/sub-categories-products-by-category/${categoryId}`
          );
          const flatProducts =
            relatedRes.data?.data?.flatMap((item) => item.products || []) || [];
          const filteredRelated = flatProducts.filter((p) => p._id !== id);
          setRelatedProducts(filteredRelated);
        }
      } catch (err) {
        console.error("Error fetching product:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [id]);

  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-out", once: true });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const fetchWishlist = async () => {
    if (!userId) {
      setWishlist(getGuestWishlist());
      return;
    }
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/wishlist/wishlist-by-user/${userId}`
      );
      const ids = res?.data?.products?.map((p) => p._id?.toString()) || [];
      setWishlist(ids);
    } catch (error) {
      console.error("❌ Error fetching wishlist:", error);
    }
  };

  useEffect(() => {
    fetchWishlist();
  }, [userId]);

  const toggleWishlist = async (productId) => {
    if (!userId) {
      setLoadingHearts((prev) => new Set(prev).add(productId));
      const updated = toggleGuestWishlistItem(productId);
      setWishlist(updated);
      toast.success(
        updated.includes(productId) ? "Added to wishlist" : "Removed from wishlist"
      );
      setLoadingHearts((prev) => {
        const newSet = new Set(prev);
        newSet.delete(productId);
        return newSet;
      });
      return;
    }

    const isLiked = wishlist.includes(productId.toString());
    setLoadingHearts((prev) => new Set(prev).add(productId));

    try {
      const endpoint = isLiked
        ? `${process.env.REACT_APP_API_URL}/wishlist/remove-from-wishlist`
        : `${process.env.REACT_APP_API_URL}/wishlist/add-to-wishlist`;

      await axios.post(endpoint, { userId, productId });
      await fetchWishlist();
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setLoadingHearts((prev) => {
        const newSet = new Set(prev);
        newSet.delete(productId);
        return newSet;
      });
    }
  };

  const handleAddToCart = async (productId) => {
    if (!userId) {
      setIsCartLoading(true);
      addToGuestCart(productId, quantity);
      toast.success("Added to cart!");
      fetchCartCount?.();
      setIsCartLoading(false);
      return;
    }

    setIsCartLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/cart/add-product-to-cart`,
        { userId, productId, quantity }
      );
      toast.success("Added to cart!");
      fetchCartCount();
    } catch (error) {
      toast.error("Failed to add to cart");
    } finally {
      setIsCartLoading(false);
    }
  };

  const handleThumbnailClick = (img, i) => {
    setSelectedImage(img);
    setSelectedIndex(i);
  };

  const handleProductClick = (id) => navigate(`/product-details/${id}`);

  if (loading) return <ProductDetailsSkeleton />;

  if (!product)
    return (
      <div className="flex justify-center items-center h-screen text-gray-500">
        Product not found.
      </div>
    );

  const isLikedMain = wishlist.includes(product._id?.toString());
  const isHeartLoadingMain = loadingHearts.has(product._id);

  const price = Number(product.price) || 0;
  const prevPrice = Number(product.previous_price) || 0;
  const discountPct =
    prevPrice > price ? Math.round(((prevPrice - price) / prevPrice) * 100) : 0;

  return (
    <div className="min-h-screen bg-white">
      {/* Breadcrumb */}
      <div className="bg-white border-b">
        <div className="w-full mx-auto px-4 md:px-10 py-2.5 flex items-center text-xs md:text-sm text-gray-600">
          <button
            onClick={() => navigate("/")}
            className="hover:text-[#9F7100] flex items-center gap-1"
          >
            <Home className="w-3.5 h-3.5" />
            Home
          </button>
          <ChevronRight className="w-3.5 h-3.5 mx-1.5 text-gray-400" />
          <span className="text-gray-900 truncate max-w-[70vw]">
            {getLocalizedText(product?.name)}
          </span>
        </div>
      </div>

      {/* Product Details Section - Amazon 3 column layout */}
      <div className="w-full mx-auto px-4 md:px-10 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-[420px_1fr_320px] gap-8">
          {/* LEFT COLUMN — Image gallery (thumbnails + main image, Amazon style) */}
          <div
            className="flex flex-col sm:flex-row gap-3 lg:sticky lg:top-20 self-start"
            data-aos="fade-right"
          >
            {/* Thumbnails */}
            <div className="order-2 sm:order-1 flex sm:flex-col gap-2 overflow-x-auto sm:overflow-visible">
              {product.images?.map((img, i) => (
                <button
                  key={i}
                  onClick={() => handleThumbnailClick(img, i)}
                  className={`flex-shrink-0 w-14 h-14 border rounded-md flex items-center justify-center overflow-hidden bg-white transition ${
                    selectedIndex === i
                      ? "border-[#9F7100] ring-1 ring-[#9F7100]"
                      : "border-gray-300 hover:border-gray-400"
                  }`}
                >
                  <img
                    src={img}
                    alt={`thumb-${i}`}
                    className="w-full h-full object-contain p-1"
                  />
                </button>
              ))}
            </div>

            {/* Main image */}
            <div className="order-1 sm:order-2 relative flex-1">
              <div className="w-full aspect-square max-w-[420px] mx-auto flex items-center justify-center bg-white">
                <img
                  src={selectedImage}
                  alt={getLocalizedText(product?.name)}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
              {/* <button className="absolute top-0 right-0 p-2 text-gray-500 hover:text-gray-800">
                <Share2 className="w-4 h-4" />
              </button>
              <p className="text-center text-xs text-[#007185] hover:text-[#C7511F] hover:underline cursor-pointer mt-1">
                Click to see full view
              </p> */}
            </div>
          </div>

          {/* CENTER COLUMN — Title, rating, badges, price(inline mobile), features */}
          <div data-aos="fade-up" className="min-w-0">
            <h1 className="text-xl md:text-2xl text-gray-900 leading-snug">
              {getLocalizedText(product?.name)}
            </h1>

            <a href="#" className="text-sm text-[#007185] hover:text-[#C7511F] hover:underline">
              Visit the {getLocalizedText(product?.brand) || "Brand"} Store
            </a>

            <div className="flex items-center gap-2 mt-2">
              <span className="text-sm text-[#007185]">
                {product.ratings?.toFixed(1) || "0.0"}
              </span>
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`w-4 h-4 ${
                      i < Math.round(product.ratings || 0)
                        ? "text-[#DE7921] fill-[#DE7921]"
                        : "text-gray-300"
                    }`}
                  />
                ))}
              </div>
              <a href="#reviews" className="text-sm text-[#007185] hover:text-[#C7511F] hover:underline">
                ({product.numReviews || 0})
              </a>
            </div>

            <hr className="my-3" />

            {/* Mobile-only price block (desktop price lives in buybox) */}
            <div className="lg:hidden mb-4">
              <div className="flex items-baseline gap-2">
                {discountPct > 0 && (
                  <span className="text-[#CC0C39] text-lg font-medium">
                    -{discountPct}%
                  </span>
                )}
                <span className="text-2xl font-bold text-gray-900">
                  {formatingPrice(convertPrice(price), currency)}
                </span>
              </div>
              {prevPrice > 0 && (
                <p className="text-sm text-gray-500">
                  M.R.P.:{" "}
                  <span className="line-through">
                    {formatingPrice(convertPrice(prevPrice), currency)}
                  </span>
                </p>
              )}
              <p className="text-xs text-gray-600 mt-1">Inclusive of all taxes</p>
            </div>

            {/* Trust icon row, Amazon style */}
            <div className="flex flex-wrap gap-x-6 gap-y-3 text-xs text-gray-700 mb-4">
              <div className="flex flex-col items-center w-16 text-center">
                <Truck className="w-6 h-6 text-gray-500 mb-1" />
                Free Delivery
              </div>
              <div className="flex flex-col items-center w-16 text-center">
                <RotateCcw className="w-6 h-6 text-gray-500 mb-1" />
                10 days Returnable
              </div>
              <div className="flex flex-col items-center w-16 text-center">
                <ShieldCheck className="w-6 h-6 text-gray-500 mb-1" />
                Secure transaction
              </div>
            </div>

            {/* Details table — Amazon "product overview" table (only data section, unchanged fields) */}
            <table className="w-full text-sm mb-4">
              <tbody>
                {getLocalizedText(product.material) && (
                  <tr className="border-b last:border-0">
                    <td className="py-1.5 pr-4 font-semibold text-gray-900 w-36 align-top">
                      Material
                    </td>
                    <td className="py-1.5 text-gray-700">
                      {getLocalizedText(product.material)}
                    </td>
                  </tr>
                )}
                {getLocalizedText(product.height) && (
                  <tr className="border-b last:border-0">
                    <td className="py-1.5 pr-4 font-semibold text-gray-900 w-36 align-top">
                      Height
                    </td>
                    <td className="py-1.5 text-gray-700">
                      {getLocalizedText(product.height)}
                    </td>
                  </tr>
                )}
                {getLocalizedText(product.weight) && (
                  <tr className="border-b last:border-0">
                    <td className="py-1.5 pr-4 font-semibold text-gray-900 w-36 align-top">
                      Weight
                    </td>
                    <td className="py-1.5 text-gray-700">
                      {getLocalizedText(product.weight)}
                    </td>
                  </tr>
                )}
                {getLocalizedText(product.finishType) && (
                  <tr className="border-b last:border-0">
                    <td className="py-1.5 pr-4 font-semibold text-gray-900 w-36 align-top">
                      Finish
                    </td>
                    <td className="py-1.5 text-gray-700">
                      {getLocalizedText(product.finishType)}
                    </td>
                  </tr>
                )}
                {getLocalizedText(product.origin) && (
                  <tr className="border-b last:border-0">
                    <td className="py-1.5 pr-4 font-semibold text-gray-900 w-36 align-top">
                      Origin
                    </td>
                    <td className="py-1.5 text-gray-700">
                      {getLocalizedText(product.origin)}
                    </td>
                  </tr>
                )}
                {getLocalizedText(product.measurement) && (
                  <tr className="border-b last:border-0">
                    <td className="py-1.5 pr-4 font-semibold text-gray-900 w-36 align-top">
                      Measurement
                    </td>
                    <td className="py-1.5 text-gray-700">
                      {getLocalizedText(product.measurement)}
                    </td>
                  </tr>
                )}
                {getLocalizedText(product.return_policy) && (
                  <tr className="border-b last:border-0">
                    <td className="py-1.5 pr-4 font-semibold text-gray-900 w-36 align-top">
                      Return Policy
                    </td>
                    <td className="py-1.5 text-gray-700">
                      {getLocalizedText(product.return_policy)}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <hr className="my-3" />

            {/* About this item */}
            <div>
              <h2 className="text-base font-bold text-gray-900 mb-2">
                About this item
              </h2>
              <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-line">
                {getLocalizedText(product?.description)}
              </p>
            </div>
          </div>

          {/* RIGHT COLUMN — Amazon Buy Box */}
          <div data-aos="fade-left" className="min-w-0">
            <div className="border border-gray-300 rounded-xl p-4 lg:sticky lg:top-20 shadow-sm">
              {discountPct > 0 && (
                <div className="flex items-baseline gap-2">
                  <span className="text-[#CC0C39] text-lg font-medium">
                    -{discountPct}%
                  </span>
                  <span className="text-2xl md:text-3xl font-bold text-gray-900">
                    {formatingPrice(convertPrice(price), currency)}
                  </span>
                </div>
              )}
              {discountPct === 0 && (
                <span className="text-2xl md:text-3xl font-bold text-gray-900">
                  {formatingPrice(convertPrice(price), currency)}
                </span>
              )}
              {prevPrice > 0 && (
                <p className="text-sm text-gray-500 mt-1">
                  M.R.P.:{" "}
                  <span className="line-through">
                    {formatingPrice(convertPrice(prevPrice), currency)}
                  </span>
                </p>
              )}
              <p className="text-xs text-gray-600 mb-3">Inclusive of all taxes</p>

              <div className="flex items-start gap-2 text-sm text-gray-800 mb-2">
                <Truck className="w-4 h-4 mt-0.5 flex-shrink-0 text-gray-500" />
                <span>
                  <span className="font-semibold">FREE delivery</span> in
                  3–5 business days.
                </span>
              </div>

              <div className="flex items-start gap-2 text-sm text-gray-700 mb-3">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-gray-500" />
                <span className="text-[#007185] hover:text-[#C7511F] hover:underline cursor-pointer">
                  Delivering to your location — Update location
                </span>
              </div>

              <p className="text-[#007600] text-sm font-semibold mb-3">
                In stock
              </p>

              {/* Quantity */}
              <div className="mb-3">
                <label className="text-xs text-gray-600 mr-2">Quantity:</label>
                <div className="inline-flex items-center border border-gray-300 rounded-md overflow-hidden">
                  <button
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    className="px-3 py-1 hover:bg-gray-100 text-gray-700"
                  >
                    −
                  </button>
                  <span className="px-4 py-1 border-x border-gray-300 text-sm">
                    {quantity}
                  </span>
                  <button
                    onClick={() => setQuantity(quantity + 1)}
                    className="px-3 py-1 hover:bg-gray-100 text-gray-700"
                  >
                    +
                  </button>
                </div>
              </div>

              {/* Amazon-style stacked buttons */}
              <div className="flex flex-col gap-2 mb-3">
                <button
                  onClick={() => handleAddToCart(product._id)}
                  disabled={isCartLoading}
                  className="flex items-center justify-center gap-2 bg-[#FFD814] hover:bg-[#F7CA00] text-gray-900 px-4 py-2.5 rounded-full text-sm font-medium border border-[#FCD200] transition disabled:opacity-70"
                >
                  {isCartLoading ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    <ShoppingCart className="w-4 h-4" />
                  )}
                  Add to Cart
                </button>
                <button
                  onClick={() => handleAddToCart(product._id)}
                  disabled={isCartLoading}
                  className="bg-[#FFA41C] hover:bg-[#FA8900] text-gray-900 px-4 py-2.5 rounded-full text-sm font-medium border border-[#FF8F00] transition disabled:opacity-70"
                >
                  Buy Now
                </button>
              </div>

              <button
                onClick={() => toggleWishlist(product._id)}
                disabled={isHeartLoadingMain}
                className="w-full flex items-center justify-center gap-2 border border-gray-300 rounded-full px-4 py-2 text-sm text-gray-800 hover:bg-gray-50 transition mb-4"
              >
                {isHeartLoadingMain ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  <Heart
                    className={`w-4 h-4 ${
                      isLikedMain ? "fill-red-500 stroke-red-500" : "stroke-gray-700"
                    }`}
                  />
                )}
                Add to Wish List
              </button>

              <hr className="mb-3" />

              <div className="text-sm space-y-1.5 text-gray-800">
                <div className="flex justify-between">
                  <span className="text-gray-500">Ships from</span>
                  <span>Bharat Karigari</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Sold by</span>
                  <span>
                    {getLocalizedText(product.brand) || "Bharat Karigari"}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Payment</span>
                  <span className="flex items-center gap-1">
                    <ShieldCheck className="w-3.5 h-3.5" />
                    Secure transaction
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Reviews — unchanged section */}
        <div className="mt-16" id="reviews" data-aos="fade-up">
          <h2 className="text-2xl font-philosopher text-[#9F7100] mb-6">
            Customer Reviews
          </h2>
          <div className="bg-white border rounded-lg p-6 text-center text-gray-500">
            No reviews yet. Be the first to review this product!
          </div>
        </div>

        {/* Related Products — unchanged section */}
        {relatedProducts.length > 0 && (
          <div className="mt-16" data-aos="fade-up">
            <h2 className="text-2xl font-philosopher text-[#9F7100] mb-6">
              Related Products
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
              {relatedProducts.map((productItem, index) => {
                const productId = productItem._id?.toString();
                const isLiked = wishlist.includes(productId);
                const isHeartLoading = loadingHearts.has(productId);

                return (
                  <div
                    key={productId}
                    onClick={() => handleProductClick(productId)}
                    className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-all cursor-pointer duration-300 relative"
                    data-aos="fade-up"
                    data-aos-delay={index * 100}
                  >
                    {/* Wishlist */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleWishlist(productId);
                      }}
                      disabled={isHeartLoading}
                      className="absolute top-3 right-3 z-10 p-2 rounded-full bg-white/90 shadow-md hover:bg-gray-100 transition-all duration-300"
                    >
                      {isHeartLoading ? (
                        <Loader2 className="w-4 h-4 text-red-500 animate-spin" />
                      ) : (
                        <Heart
                          className={`w-5 h-5 ${
                            isLiked
                              ? "fill-red-500 stroke-red-500"
                              : "stroke-gray-800 hover:scale-110"
                          } transition-all`}
                        />
                      )}
                    </button>

                    {/* Image */}
                    <div className="relative bg-[#E5E5E5] overflow-hidden aspect-square">
                      <img
                        src={
                          productItem.images?.[0] ||
                          "https://via.placeholder.com/300x300?text=No+Image"
                        }
                        alt={getLocalizedText(productItem?.name)}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>

                    {/* Info */}
                    <div className="p-3 md:p-4">
                      <div className="flex justify-center gap-1 mb-2">
                        {[...Array(5)].map((_, i) => (
                          <Star
                            key={i}
                            className={`w-4 h-4 ${
                              i < Math.round(productItem.ratings)
                                ? "text-yellow-400 fill-yellow-400"
                                : "text-gray-300"
                            }`}
                          />
                        ))}
                        <span className="text-xs text-gray-500 ml-1">
                          {productItem.ratings?.toFixed(1) || "0.0"}
                        </span>
                      </div>

                      <h3 className="text-xs sm:text-sm text-gray-700 text-center mb-2 line-clamp-2 min-h-[2.5rem] leading-tight">
                        {getLocalizedText(productItem?.name)}
                      </h3>

                      <div className="text-center">
                        <div className="flex items-center justify-center gap-2">
                          {productItem.previous_price && (
                            <span className="text-xs sm:text-sm text-gray-400 line-through">
                              {formatingPrice(
                                convertPrice(productItem.previous_price),
                                currency
                              )}
                            </span>
                          )}
                          <span className="text-base sm:text-lg font-bold text-gray-900">
                            {formatingPrice(
                              convertPrice(productItem.price),
                              currency
                            )}
                          </span>
                        </div>
                      </div>

                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAddToCart(productId);
                        }}
                        disabled={isCartLoading}
                        className="mt-3 w-full bg-white border-2 border-gray-900 text-gray-900 py-2.5 text-sm font-bold rounded-lg hover:bg-gray-900 hover:text-white transition-all duration-300 transform hover:scale-[1.02] disabled:opacity-70"
                      >
                        {isCartLoading ? (
                          <div className="flex justify-center items-center gap-2">
                            <Loader2 className="w-4 h-4 animate-spin" />
                            ADDING...
                          </div>
                        ) : (
                          "ADD TO CART"
                        )}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductDetailsPage;